<template>
  <div>
    <div v-if="localChartData.length === 0">
    </div>
    <div v-else v-for="(obj, index) in localChartData" :key="obj.key || index" class="mb-base">
      <div class="w-full items-left">
        <h4>{{obj.pm}}</h4>
      </div>

      <vue-apex-charts
        v-if="obj.series.length > 0"
        type="line"
        height="350"
        :options="obj.chartOptions"
        :series="obj.series"
      >
      </vue-apex-charts>

      <vs-collapse accordion>
        <vs-collapse-item v-if="obj.series.length > 0">
          <div slot="header" style="font-size:12px;" class="right"> 
            <b >{{$t('raterList')}} </b>
          </div>
          <table>
            <tr>
              <th> <b style="font-size:12px;"> {{$t('Invited')}}</b></th>
            </tr>
            <tr v-for="(e, i) in obj.series" :key="i">
              <td >
                <table class="w-full mx-0" >
                  <tr>
                    <td class="left" style="margin-left:10%;"><b>{{e.email}}</b></td>
                    <td class="right"> 
                      <feather-icon
                        icon="EyeIcon"
                        title="Feedback Details"
                        svgClasses="h-5 float-right hover:text-primary cursor-pointer" 
                        @click="scheduleSendEndorsementInvite(e)" 
                        type="filled"
                      >
                      </feather-icon>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </vs-collapse-item>
      </vs-collapse>

      <vs-popup  :title="$t('skillDetails.action2.a1')+inviteUserName" :active.sync="scheduleInvite" >
        <div class="con-exemple-prompt">
          <vs-list-item v-for="(date, index) in feedback_sent_dates" :key="index" :title="date.finalDate" >
            <table style="width:100%;overflow-x: hidden;">
              <tr v-if="(new Date(date.feedbackSentDate)) <(new Date()) &&  date.emailStatus===0">
                <b>{{$t('skillDetails.action2.a8')}}</b>
                <a
                  size="small"
                  class="ml-2"
                  title="System follow-up is sent once, follow-up again with your personal email"
                  @click="sendFollowupMail(date.id)"
                >{{$t('skillDetails.action2.a9')}}</a
                >
              </tr>
              <tr v-else-if="(date.currentGap >0) &&  date.emailStatus===1 && index===0 ">
                <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a30')}}</b>
              </tr>
              <tr v-else-if="(date.currentGap >0) &&  date.emailStatus===1 && index>0">
                <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a10')}}</b>
              </tr>
              <tr v-else-if="(new Date(date.feedbackSentDate)) <(new Date()) &&date.emailStatus===0 &&date.externalTokenExpired===1 ">
                <b>{{$t('skillDetails.action2.a8')}}</b>
                <vs-button
                    size="small"
                    class="ml-4"
                    @click="sendFollowupMail(date.id)"
                    title="Followup already send"
                >{{$t('skillDetails.action2.a9')}}</vs-button>
                <br>
                <p v-if="date.followupCount===1">Followed up {{date.followupCount}} times</p>
                <p v-else>Followed up {{date.followupCount}} times</p>              
              </tr>
              <tr v-else-if="(new Date(date.feedbackSentDate)) <(new Date()) &&date.emailStatus===6 &&date.externalTokenExpired===1 ">
                <b  class="mr-4">{{$t('skillDetails.action2.a8')}}</b>
                <b>{{$t('skillDetails.action2.a23')}}</b>
              </tr>
              <tr :title="date.notesDescription?date.notesDescription:'No Note Added'" v-else-if="(date.currentGap === -1 && date.emailStatus===4)">
                <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a18')}}</b>
              </tr>
              <tr v-else-if="(new Date(date.feedbackSentDate)) <(new Date()) &&date.emailStatus===1 ">
                <b>{{$t('skillDetails.action2.a8')}}</b>
                <vs-button
                    size="small"
                    class="ml-4"
                    @click="sendFollowupMail(date.id)"
                    title="Followup already send"
                >{{$t('skillDetails.action2.a9')}}</vs-button>
                <br>
                <p v-if="date.followupCount===1">Followed up {{date.followupCount}} times</p>
                <p v-else>Followed up {{date.followupCount}} times</p>
              </tr>
              <tr v-else-if="(new Date(date.feedbackSentDate)) >(new Date()) && date.emailStatus===0">
                <b>{{$t('skillDetails.action2.a12')}}</b>
              </tr>
              <tr v-else-if="(date.currentGap >0 && date.emailStatus ===4 && index>0) ">
                <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a10')}}</b>
              </tr>
              <tr v-else-if="(date.currentGap >0 && date.emailStatus ===4 && index===0) ">
                <b :title="date.notesDescription?date.notesDescription:'No Note Added'" >{{$t('skillDetails.action2.a30')}}</b>
              </tr>
              <tr v-else-if="(date.currentGap === 0 && date.emailStatus===5)">
                <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a11')}}</b>
              </tr>  
              <tr v-else-if="(date.currentGap === 0 && date.emailStatus===4)">
                <b :title="date.notesDescription?date.notesDescription:'No Note Added'"> {{$t('skillDetails.action2.a11')}}</b>
              </tr>  
              <tr v-else-if="(date.externalTokenExpired === 1 && date.emailStatus===1)">
                <b >{{$t('skillDetails.action2.a13')}}</b>
              </tr>
              <tr v-else-if="(date.externalTokenExpired === 1 && date.emailStatus===6)">
                <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a28')}}</b>
              </tr>
              <tr v-else-if="date.emailStatus===2">
                <b>{{$t('skillDetails.action2.a8')}}</b>
                <vs-button
                  size="small"
                  class="ml-4"
                  @click="sendFollowupMail(date.id)"
                  title="Followup already send"
                >{{$t('skillDetails.action2.a9')}}</vs-button>
                <br>
                <p v-if="date.followupCount===1">Followed up {{date.followupCount}} times</p>
                <p v-else>Followed up {{date.followupCount}} times</p>
              </tr>
            </table>
          </vs-list-item>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
  import i18n from "@/i18n/i18n";
  import VueApexCharts from 'vue-apexcharts'

  // Deep clone utility to protect Vuex from ApexCharts
  function cloneChartData(obj) {
    if (obj === null || typeof obj !== "object") {
      return obj; 
    }
    if (obj instanceof Date) {
      return new Date(obj.getTime());
    }
    if (Array.isArray(obj)) {
      return obj.map(item => cloneChartData(item));
    }
    const clonedObj = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        clonedObj[key] = cloneChartData(obj[key]);
      }
    }
    return clonedObj;
  }

  export default {
    name: 'EndorsementChart',
    components: {
      VueApexCharts
    },
    data() {
      return {
        localChartData: [], 
        userType: this.$store.state.AppActiveUser.userType,
        endorsement_invite_data: null,
        endorsementInvitePrgmsId:'',
        endorsement_invite_emails: [],
        feedback_sent_dates: [],
        inviteUserName:null,
        confirmcancelSingleEmail:false,
        confirmExpireSingleEmail:false,
        externalFeedbackId:null,
        endorsementChartObj: {},
        custom_progress_measures: [],
        terminology:null,
        goalCompletedPopup: false,
        scheduleInvite: false,
        confirmscheduleInvite:false,
        resetscheduleInvite:false,
        confirmResetscheduleInvite:false,
        markGoalCompletedConfirmation:false,
        email:'',
        endorsementInvitePrgms:null,
        edorsementId:'',
        compenTencyId:'',
        emailScheduleData:{},
        InviteSkillName:"",
        skillName:"",
        training_duration:"",
        cancelDisable:true,
        traineeName:"",
        markGoalCompletedEmail:false,
        progress_measures_list: [],
        CCD: this.$t("addNewSkill.data"),
        endorsementNewObj: {},
        themeColors: [
          '#7367F0', '#28C76F', '#EA5455', '#FF9F43',
          '#1E1E1E','#4800FF','#606060','#7F0000',
          '#FF006E','#0094FF','#00FFFF','#007F46',
          '#7F6A00','#FF7F7F','#7F0037','#007F0E',
          '#7FC9FF','#B200FF','#FF6A30','#7FFFC5',
          '#FFE97F','#7F92FF','#D67FFF','#007F7F'
        ]
      }
    },
    watch: {
      '$store.state.endorsementInvite.chartObj': {
        immediate: true,
        deep: true,
        handler(newChartObj) {
          this.buildLocalChartData(newChartObj);
        }
      }
    },
    computed: {
      coachType(){
        if(window.$cookies.get('companyName')==='GALA.GAMES'){
          return "Mentor";
        }else{
          return "Coach";
        }
      }
    },
    methods: {
      buildLocalChartData(chartObj) {
        if (!chartObj || Object.keys(chartObj).length === 0) {
          this.localChartData = [];
          return;
        }

        const result = [];
        for (const key in chartObj) {
          if (Object.prototype.hasOwnProperty.call(chartObj, key)) {
            const original = chartObj[key];
            const clonedOriginal = cloneChartData(original);
            clonedOriginal.key = key; 

            // 1. Force Markers so the dots actually show up with colours
            if (!clonedOriginal.chartOptions.markers) clonedOriginal.chartOptions.markers = {};
            clonedOriginal.chartOptions.markers.size = 8;
            clonedOriginal.chartOptions.markers.strokeWidth = 0;
            clonedOriginal.chartOptions.markers.hover = { sizeOffset: 3 };

            // 2. Override Tooltip logic to make it SHARED and LEFT-ALIGNED
            if (!clonedOriginal.chartOptions.tooltip) clonedOriginal.chartOptions.tooltip = {};
            
            // This tells ApexCharts to grab all data points that share the X-axis hover location
            clonedOriginal.chartOptions.tooltip.shared = true;
            clonedOriginal.chartOptions.tooltip.intersect = false;

            // Preserve the original custom function from your Vuex state if it exists
            const originalCustomTooltip = clonedOriginal.chartOptions.tooltip.custom;

            // Inject our new wrapper function
            clonedOriginal.chartOptions.tooltip.custom = function(opts) {
              const { series, dataPointIndex, w } = opts;
              
              let html = '<div style="padding: 10px; background: #fff; text-align: left; box-shadow: 0 4px 15px rgba(0,0,0,0.1);">';
              let hasData = false;
              
              // Loop through ALL active series (Harry, Mitsi, etc.)
              w.config.series.forEach((s, idx) => {
                const val = series[idx][dataPointIndex];
                
                // If this specific advisor gave a rating here
                if (val !== null && typeof val !== 'undefined') {
                  hasData = true;
                  const color = w.globals.colors[idx];
                  
                  if (originalCustomTooltip && typeof originalCustomTooltip === 'function') {
                    // Ask the original function for this person's specific tooltip text
                    let origHtml = originalCustomTooltip({ series, seriesIndex: idx, dataPointIndex, w });
                    
                    // Force the text to be left-aligned (overrides any existing centering)
                    if (typeof origHtml === 'string') {
                       origHtml = origHtml.replace(/text-align:\s*center/gi, 'text-align: left');
                    }

                    // Stack it cleanly with a colored border strip to easily identify who is who
                    html += `
                      <div style="border-left: 4px solid ${color}; padding-left: 10px; margin-bottom: 12px; text-align: left !important;">
                        ${origHtml}
                      </div>
                    `;
                  } else {
                    // Fallback just in case no custom tooltip exists
                    html += `
                      <div style="border-left: 4px solid ${color}; padding-left: 10px; margin-bottom: 10px; text-align: left;">
                        <strong style="font-size: 13px; color: #333;">Advisor: ${s.name}</strong><br/>
                        <span style="font-size: 12px; color: #555;">Rating: ${val}</span>
                      </div>
                    `;
                  }
                }
              });
              
              html += '</div>';
              
              // Return the combined HTML blocks
              return hasData ? html : null;
            };

            result.push(clonedOriginal);
          }
        }
        this.localChartData = result;
      },
      // ... KEEP REST OF METHODS EXACTLY THE SAME ...
      sendFollowupMail(id){
        console.log('id',id);
        this.$store
          .dispatch("endorsementInvite/fetchFeeddata",{query:{id:id}})
          .then(feeddata =>{
            console.log('feeddata',feeddata);
            this.$store
              .dispatch("endorsement-invite-prgms/find",{query:{id:feeddata.data[0].endorsementInvitePrgmsId}})
              .then(inviteePrgms =>{
                console.log('single invitee prgms data',inviteePrgms);
                this.$store
                  .dispatch("endorsement-invite/find",{query:{id:inviteePrgms.data[0].endorsementInviteId}})
                  .then(InviteeData =>{
                    console.log('Invitee Data',InviteeData);
                    this.$store
                        .dispatch("invitee-message-id/find",{query:{externalToken:feeddata.data[0].externalToken}})
                        .then(inviteeMessageData =>{
                          console.log('Invitee Data',inviteeMessageData);
                    this.$store
                      .dispatch("addSkill/findCompetency",{query:{id:InviteeData.data[0].traineeCompetenciesId}})
                      .then(traineeCompetency =>{
                        console.log('Invitee Data',traineeCompetency);
                        let followupCountUpdate =feeddata.data[0].followupCount+1;
                        this.$store
                          .dispatch("userManagement/fetchUser",traineeCompetency.data[0].usersId)
                          .then(users =>{
                            const characteristicId =  traineeCompetency.data[0].competencyId.split("-")[0];
                            const competencyId =  traineeCompetency.data[0].competencyId.split("-")[1];
                            console.log(characteristicId, competencyId);
                            const competencies = this.CCD[characteristicId].competencies;
                            console.log(competencies);
                            const currentCompetency = competencies[competencyId];
                            console.log(currentCompetency);
                            this.currentCompetency = currentCompetency;
                            this.InviteSkillName = currentCompetency.comp;
                            console.log('skill name',this.InviteSkillName);
                            let followUpVariable='';
                            if(feeddata.data.length===1){
                              followUpVariable='benchmark';
                            }else{
                              followUpVariable='followup';
                            }
                            this.traineeName=users.firstName+' '+users.lastName;
                            const  extFeedObj = {
                              traineeName: users.firstName+' '+users.lastName,
                              traineeEmail: users.email,
                              playerEmail: users.email,
                              mailType:"followup_invitation_sent",
                              inviteeEmail: InviteeData.data[0].inviteeEmail,
                              inviteUserName: InviteeData.data[0].inviteUserName,
                              skillName:this.InviteSkillName,
                              trainingDuration: traineeCompetency.data[0].trainingDuration,
                              endorsementInvitePrgmsId: inviteePrgms.data[0].id,
                              externalToken:feeddata.data[0].externalToken,
                              feedbackId:feeddata.data[0].id,
                              companyName:window.$cookies.get('companyName'),
                              messageId:inviteeMessageData.data[0].messageId,
                              lang: ((window.$cookies.get('locale') =='es')?'es':'en'),
                              externalTokenExpired: false,
                              feedbackSentDate: feeddata.data[0].feedbackSentDate,
                              followupCount:followupCountUpdate,
                              mailTypeStatus:followUpVariable,
                              emailStatus:2
                            };
                            this.$store
                              .dispatch("external-feedback/patch", [feeddata.data[0].id, extFeedObj])
                              .then(res => {
                                for(let i=0;i<InviteeData.data[0].endorsementInvitePrgms.length;i++){
                                  let followupStatus={
                                    emailStatus:2,
                                    followupCount:followupCountUpdate,
                                  }
                                  this.$store
                                    .dispatch("endorsementInvite/fetchFeeddata",{query:{endorsementInvitePrgmsId:InviteeData.data[0].endorsementInvitePrgms[i].id, currentGap: null,
                                        feedbackReceivedDate: null}})
                                    .then(res => {
                                      console.log(res.data);
                                         this.$store
                                         .dispatch("external-feedback/patch", [res.data[0].id, followupStatus])
                                         .then(res => { console.log('result',res) })
                                         .catch(err => {
                                           console.log("email resend data not updated", err);
                                            });
                                    })
                                    .catch(err => {
                                    console.log("email resend data not updated", err);
                                  });
                                }
                                this.$vs.notify({
                                  color: "primary",
                                  title: i18n.t('notification.user.components.emailSent.success.e1'),
                                  text:  i18n.t('notification.user.components.emailSent.success.e2'),
                                });
                                console.log("email resend data updated", res);
                              })
                              .catch(err => {
                                console.log("email resend data not updated", err);
                              });
                            console.log('Invitee Data',extFeedObj);
                          })
                          .catch(err => {
                            console.log("error goal mark complete", err);
                          })
                      })}).catch(err => {
                      console.log("error goal mark complete", err);
                    })
                      .catch(err => {
                        console.log("error goal mark complete", err);
                      })
                  })
                  .catch(err => {
                    console.log("error goal mark complete", err);
                  })
              })
              .catch(err => {
                console.log("error goal mark complete", err);
              });
          })
          .catch(err => {
            console.log("error goal mark complete", err);
          });
      },
      formatDate(sentDate) {
        let date = new Date(sentDate)
        date = `${date.getFullYear()  }-${  date.getMonth() + 1  }-${  date.getDate()}`;
        return date;
      },
      scheduleSendEndorsementInvite(data){
        console.log('endEndorsementInviteId',data.name);
        this.inviteUserName=data.name;
        console.log('app active user',this.$store.state.AppActiveUser);
        this.traineeName=this.$store.state.AppActiveUser.firstName+' '+this.$store.state.AppActiveUser.lastName;
        const query={query:{
            endorsementInviteId:data.endorsementInviteId,progressMeasureId:data.pmId}}
        this.$store
          .dispatch("endorsementInvite/fetchInviteePrgms", query)
          .then(res => {
            console.log("invitee data", res);
            let query1={},query2={}, count=0;
            for(let j=0;j<res.data.length;j++){
              for(let k=0;k<res.data[j].externalFeedback.length;k++){
                count=count+res.data[j].externalFeedback[k].externalTokenExpired;
              }
            }
              const query3= {
                query: {
                  endorsementInvitePrgmsId: res.data[res.data.length-1].id,
                }
              }
              this.$store
                .dispatch("endorsementInvite/fetchFeeddata", query3)
                .then(res1 => {
                  console.log('',res1);
                  let count = 1;
                  let count1 = 1;
                  for (let i = 0; i < res1.data.length; i++) {
                    if ((new Date(res1.data[i].feedbackSentDate)) > (new Date())) {
                      if (res1.data[i].emailStatus === 1) {
                        count = count + res1.data[i].emailStatus;
                        console.log('C', count);
                      } else if (res1.data[i].emailStatus === 5 || res1.data[i].emailStatus === 6) {
                        count1 = count + res1.data[i].emailStatus;
                        console.log('C', count);
                      }
                    }
                  }
                  this.scheduleInvite = true;
                  for(let k=0;k<res1.data.length;k++){
                    if(res1.data[k]["feedbackReceivedDate"]!==null){
                      res1.data[k]["finalDate"]=res1.data[k]["feedbackSentDate"]+' / '+res1.data[k]["feedbackReceivedDate"];
                    }else{
                      res1.data[k]["finalDate"]=res1.data[k]["feedbackSentDate"];
                    }
                  }
                  this.feedback_sent_dates = res1.data;
                  console.log('faadback data all',res1.data);
                  this.edorsementId = res1.data;
                  const query2 = {query: {id: data.endorsementInviteId}}
                  this.$store
                    .dispatch("endorsementInvite/fetchInvitees", query2)
                    .then(res => {
                      this.email = res.data;
                      this.compenTencyId = res.data[0].traineeCompetenciesId;
                      this.inviteUserName=res.data[0].inviteUserName;
                      this.$store
                        .dispatch("addSkill/findCompetency",{query:{id:this.compenTencyId}})
                        .then(traineeCompetency =>{
                          const date=new Date (traineeCompetency.data[0].trainingDuration);
                          this.training_duration= date.getDate()+'/'+ date.getMonth()+'/'+date.getFullYear();
                          const competencyId =  traineeCompetency.data[0].competencyId.split("-")[0];
                          console.log(competencyId);
                          const competencies = this.CCD[competencyId].competencies;
                          console.log(competencies);
                        }).catch(err => {
                        console.log("data not found", err);
                      });
                      console.log("email dd", res);
                    })
                    .catch(err => {
                      console.log("error goal mark complete", err);
                    });
                  console.log("feed data", this.email);
                })
                .catch(err => {
                  console.log("data not found", err);
                });

          })
          .catch(err => {
            console.log("data not found", err);
          });
      },
    },
    created () {
      console.log(this.$store.state.endorsementInvite.chartObj);
      const url =this.$route.path.split('/');
      const id=url[3]
      this.$store
        .dispatch("endorsementInvite/fetchFeeddata",{query:{id:id}})
        .then(feeddata =>{
          console.log('feeddata',feeddata);
          this.$store
            .dispatch("endorsement-invite-prgms/find",{query:{id:feeddata.data[0].endorsementInvitePrgmsId}})
            .then(inviteePrgms =>{
              console.log('single invitee prgms data',inviteePrgms);
              this.$store
                .dispatch("endorsement-invite/find",{query:{id:inviteePrgms.data[0].endorsementInviteId}})
                .then(InviteeData =>{
                  console.log('Invitee Data',InviteeData);
                  this.$store
                    .dispatch("addSkill/findCompetency",{query:{id:InviteeData.data[0].traineeCompetenciesId}})
                    .then(traineeCompetency =>{
                      console.log('Invitee Data',traineeCompetency);
                      this.$store
                        .dispatch("userManagement/fetchUser",traineeCompetency.data[0].usersId)
                        .then(users =>{
                          const characteristicId =  traineeCompetency.data[0].competencyId.split("-")[0];
                          const competencyId =  traineeCompetency.data[0].competencyId.split("-")[1];
                          console.log(characteristicId, competencyId);
                          const competencies = this.CCD[characteristicId].competencies;
                          console.log(competencies);
                          const currentCompetency = competencies[competencyId];
                          console.log(currentCompetency);
                          this.currentCompetency = currentCompetency;
                          this.InviteSkillName = currentCompetency.comp;
                          console.log('skill name',this.InviteSkillName);
                          this.traineeName=users.firstName+' '+users.lastName;

                        })
                        .catch(err => {
                          console.log("error goal mark complete", err);
                        })
                    })
                    .catch(err => {
                      console.log("error goal mark complete", err);
                    })
                })
                .catch(err => {
                  console.log("error goal mark complete", err);
                })
            })
            .catch(err => {
              console.log("error goal mark complete", err);
            });
        })
        .catch(err => {
          console.log("error goal mark complete", err);
        });
    }
  };
</script>

<style scoped>
  .items-left {
    text-align: left;
    text-align: -moz-left;
    text-align: -webkit-left;
  }
   .truncate-pm {
     width: 80%;
     white-space: normal !important;
     margin-left: 1.5rem;
   }
  .no-box-shadow {
    box-shadow: none !important;
  }
  .t-sd {
    white-space: normal !important;
  }
  .skill-icon {
    width: 25px;
    height: 25px;
  }
  .items-center {
    text-align: center;
    text-align: -moz-center;
    text-align: -webkit-center;
  }

  table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 80%;
    margin-left:10%;margin-right:10%;
  }

  .left {
    border: 1px solid #ffffff;
    text-align: left;
    padding: 8px;
  }
  .right {
    border: 1px solid #ffffff;
    text-align: right;
    padding: 8px;
  }
  .con-vs-dialog .vs-dialog footer .vs-button:last-of-type {
    display: none;
  }
  .vs-button-flat {
    display: none;
  }
  .con-vs-popup .vs-popup {
    -webkit-transition: all .2s;
    transition: all .2s;
    z-index: 100;
    width:400px ;
    margin: 10px;
    max-width: 400px;
    max-height: calc(100% - 30px);
    border-radius: 6px;
    -webkit-box-shadow: 0 5px 20px 0 rgba(0,0,0,.1);
    box-shadow: 0 5px 20px 0 rgba(0,0,0,.1);
    background: #fff;
    -webkit-animation: rebound .3s;
    animation: rebound .3s;
  }
  tr:nth-child(even) {
    background-color: #ffffff;
  }
</style>